module.exports = __webpack_public_path__ + "static/img/52.ba9ca69f.jpg";